import { Filter } from '@cubejs-client/core';
import { useCubeQuery } from '@cubejs-client/react';
import { formatNumber, NumberFormatPreset, QuickViewWidget, useScrollIntoView } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { useDateRange } from '../../components/DateRangeProvider';
import { I18nNamespace } from '~/common/types';
import { SpendType } from '~/common/types/cubes/SpendType';
import { useResponsibleUsersFilter } from '~/components/ResponsibleUsersProvider';
import { useSpendTypeFilter } from '~/hooks';
import { convertDateRangeToTimeDimension, getSegments } from '~/util/cube';

const formatValueCompact = formatNumber(NumberFormatPreset.CURRENCY_COMPACT);
const formatValue = formatNumber(NumberFormatPreset.CURRENCY);

type NegotiationsTotalSavingWidgetProps = {
  filters?: Filter[];
  spendType: SpendType;
};
export const CUBE = 'AverageNegotiationSavings';
export const NegotiationsTotalSavingsWidget = ({ filters, spendType }: NegotiationsTotalSavingWidgetProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationsTotalSavingWidget' });
  const [widgetRef, active] = useScrollIntoView({ hash: 'negotiations-total-saving-widget' });
  const { currentDateRange } = useDateRange();
  const responsibleUsersFilter = useResponsibleUsersFilter(`${CUBE}.responsible_uuid`);
  const spendTypeFilter = useSpendTypeFilter({ spendType, cubeTotalVolumeField: `${CUBE}.quote_total` });
  const queryValue = useCubeQuery({
    measures: [`${CUBE}.total_saving`],
    timeDimensions: convertDateRangeToTimeDimension(`${CUBE}.date`, currentDateRange),
    filters: [...(filters || []), responsibleUsersFilter, ...spendTypeFilter],
  });

  const { totalValue } = getSegments(queryValue);

  return (
    <QuickViewWidget
      ref={widgetRef}
      active={active}
      loading={queryValue.isLoading}
      title={t('title')}
      subTitle={t('subTitle')}
      value={formatValueCompact(totalValue)}
      valueTooltip={formatValue(totalValue)}
      data-intercom-target="NegotiationsTotalSavingWidget"
    />
  );
};
